export default {
  accept: 'Accept',
  reject: 'Reject',
  companyHasInvited: '{{companyName}} has invited you to join their company as a staff',
  sentPasswordLinkInEmail: 'An email to set up your new password have been sent to your email. <br/><br/> Please check your email and set up your new password. Thank you.'
};